module.exports = __webpack_public_path__ + "static/media/Single Matting Vertical Logo.4a32ae92.png";